import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  error: string
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  error: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SUBMIT_LABORER_PRO_SURVEY_ASYNC,
    Actions.SUBMIT_LABORER_PRO_SURVEY_SUCCESS,
    Actions.SUBMIT_LABORER_PRO_SURVEY_FAIL,
    {},
    {
      error: string
    }
  >,
): State => {
  switch (action.type) {
    case Actions.SUBMIT_LABORER_PRO_SURVEY_ASYNC:
    case Actions.SUBMIT_LABORER_PRO_SURVEY_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }

    case Actions.SUBMIT_LABORER_PRO_SURVEY_FAIL: {
      return {
        ...state,
        ...action.status,
        error: action.payload?.error || '',
      }
    }

    default:
      return state
  }
}
